import { useEffect,  React, useState } from "react";
import { TextInput, RadioButton, RadioButtonGroup, Content, Button, Grid, Column, InlineNotification, Loading } from '@carbon/react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

const schema_registro = yup.object().shape({
    txtCorreo: yup.string().email("Escribe un correo válido.").max(100).required("Este campo es requerido."),
    txtPassword: yup.string().required("Este campo es requerido.").max(50)
},
)

const ValidaRFC = () => {

    const headers = new Headers(); headers.append('Content-Type', 'application/json');
    const [loading, setLoading] = useState(false);
    const [isRfcReg, setIsRfcReg] = useState(false);
    const [msgResponse, setMsgResponse] = useState([]);
    const [msgRegistro, setMsgRegistro] = useState([]);
    const [rdoTipoConfig, setRdoTipoConfig] = useState("1");
    const [rfc, setRFC] = useState("");
    const [rfcResponse, setRfcResponse] = useState([]);
    const [disableBtonAceptar, setDisableBtonAceptar] = useState(false);
  
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema_registro)
    });

    var VR = {
        ColorHrLine: ({ color }) => (<hr style={{ color: color, backgroundColor: color, height: 2 }} />),
        spanHeight: ({ height }) => (<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: height }} />),
        hideMesg: function() {
            setMsgResponse({ "showMsg": 0 });
        },
        hideMsgRegistro: function() {
            setMsgRegistro({ "showMsg": 0 });
        },
        validarRFC: function () {
            let vrfc = {}
            var rfc =  document.getElementById("txtRfc").value;
            var curp =  document.getElementById("txtCurp").value;

            vrfc.RFC = rfc;
            vrfc.CURP = curp;
            setRFC(rfc);

            fetch(process.env.REACT_APP_URL_SERVICE_VALIDA_RFC, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(vrfc)
            }).then((res) => res.json()).then((resp) => {
          
                setRfcResponse(resp);
                setIsRfcReg((resp.estatus === 0)?true:false);
                setMsgResponse({ "showMsg": 1, "kind":"success", "Mensaje": resp.Mensaje});
            });
        },
        validaPregunta: function(){

            if(rdoTipoConfig == 1){ // No
                document.getElementById("txtRfc").value = "";
                VR.hideMesg();
                setIsRfcReg(false);
            } 
            /*else { // Si
                window.location.href = `/#/registro?rfc=${rfc}`;
            }*/
        }
    }

    const onOptionChange = e =>  {
        const value = e.target.value;
        setRdoTipoConfig(value);
        setDisableBtonAceptar((value == 2)?true:false);
    }

    async function agregarRegistro (formData){
        setLoading(true);
        let arRequest = {}
        let req = {}

       arRequest.RFC = rfc;
       arRequest.NUM_EMPLEADO = rfcResponse.NUM_EMPLEADO;
       arRequest.NOMBRE = rfcResponse.Nombre;
       arRequest.CURP = rfcResponse.CURP;
       arRequest.Correo = formData.txtCorreo;
       arRequest.Password = formData.txtPassword;
       arRequest.Llave = "";
       arRequest.FechaEntrada = "";
       arRequest.FecUltMod = "";

       req.SDTUsuario = arRequest;

       fetch(process.env.REACT_APP_URL_SERVICE_REGISTRO, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(req)
        }).then((res) => res.json()).then((resp) => {
    
            setMsgRegistro({ "showMsg": 1, "kind":(resp.estatus == 0)?"success":"error", "Mensaje": resp.Mensajes});

            setTimeout(() => {
                setLoading(false);
                if(resp.estatus == 0){
                    window.location.href = `/#/`;
                }
              }, 3000);
           
        });
    }

    useEffect(() => {

    }, []);
 
    return (
       <>
        <Content>
            <Loading className={'some-class'} active={loading} withOverlay={true} />
            <Grid>
                <Column lg={16} md={8} sm={4} className="css-s231ta">
                    <Grid>
                        <Column lg={16} md={8} sm={4}> 
                        <VR.spanHeight height="2vh" />
                            <div style={{textAlign: "center"}} >
                                <h3>Validar información.</h3>
                            </div>
                        </Column>
                    </Grid>
                    <VR.spanHeight height="3vh" />
                    <Grid>
                            <Column lg={2} md={2} sm={2}  >  </Column>
                            <Column lg={4} md={4} sm={4}  > 
                                <TextInput id="txtRfc" type="text" 
                                        labelText="RFC" 
                                        placeholder="Introduce el RFC" 
                                />
                            </Column>
                            <Column lg={4} md={4} sm={4}  > 
                                <TextInput id="txtCurp" type="text" 
                                        labelText="CURP" 
                                        placeholder="Introduce el CURP" 
                                />
                            </Column>
                            <Column lg={4} md={4} sm={4}  >  
                                <VR.spanHeight height="2.5vh" />
                                <Button id="btnRegEmp" 
                                        kind="primary" 
                                        type="button" 
                                        onClick={VR.validarRFC} >
                                Validar
                                </Button>
                            </Column>
                    </Grid>
                    <VR.spanHeight height="12vh" />
                    <Grid>
                            <Column lg={2} md={2} sm={2}  >  </Column>
                            {isRfcReg ?
                            <>
                            <Column lg={8} md={8} sm={4}  > 
                                {(msgResponse.showMsg === 1) &&
                                        <div style={{textAlign: "left"}} >
                                            <h4>{msgResponse.Mensaje}</h4>
                                        </div>
                                }
                                <VR.spanHeight height="4vh" />
                                <RadioButtonGroup legendText="" name="radio-button-group" defaultSelected="1">
                                    <RadioButton labelText="No" 
                                                value="1" 
                                                id="rdo-1" 
                                                onClick={onOptionChange} />
                                    <RadioButton labelText="Si" 
                                                value="2" 
                                                id="rdo-2"  
                                                onClick={onOptionChange} />
                                </RadioButtonGroup>
                            </Column>
                            <Column lg={4} md={4} sm={4}  >   
                                <VR.spanHeight height="2.5vh" />
                                <Button id="btnRegEmp" 
                                    kind="secondary" 
                                    type="button" 
                                    onClick={VR.validaPregunta} 
                                    disabled={disableBtonAceptar}
                                >
                                    Aceptar
                                </Button>
                            </Column>
                            </>
                            : 
                            <>
                            <Column lg={8} md={8} sm={4}  > 
                                <div style={{textAlign: "left"}} >
                                    <h4>{msgResponse.Mensaje}</h4>
                                </div>
                            </Column>
                            <Column lg={4} md={4} sm={4}  > </Column>
                            </>
                            }
                    </Grid>
                    <VR.spanHeight height="10vh" />
                    {rdoTipoConfig == 2 ?
                            <>
                    <form onSubmit={handleSubmit(agregarRegistro)}>
                        <Grid>
                            <Column lg={2} md={2} sm={2}  >  </Column>
                            <Column lg={4} md={4} sm={4}>
                                <TextInput id="txtCorreo" type="text" 
                                    labelText="Correo"
                                    maxLength="100" 
                                    placeholder="Ingresa un correo"
                                    {...register("txtCorreo")}
                                    invalid={errors.txtCorreo}
                                    invalidText={errors.txtCorreo?.message}
                                />
                            </Column>
                            <Column lg={4} md={4} sm={4}>
                                <TextInput.PasswordInput id="txtPassword" type="password"
                                    placeholder="Ingresa un password" 
                                    maxLength="50" 
                                    labelText="Password"
                                    {...register("txtPassword")} 
                                    invalid={errors.txtPassword} 
                                    invalidText={errors.txtPassword?.message}
                                />
                            </Column>                         
                            <Column lg={4} md={4} sm={4} > 
                                <VR.spanHeight height="3vh" />
                                <Button id="btnRegEmp" kind="secondary" type="submit">Registrar</Button>
                            </Column>
                            <Column lg={2} md={2} sm={2}  > </Column>
                        </Grid>
                    </form>
                    </> : 
                            <>
                            
                            </>
                            
                    }
                    <VR.spanHeight height="5vh" />
                    <Grid>
                        <Column lg={2} md={2} sm={2}> </Column>
                        <Column lg={12} md={12} sm={12}> 
                                {msgRegistro.showMsg === 1 && 
                                <InlineNotification 
                                        title={msgRegistro.Mensaje}
                                        kind={msgRegistro.kind} 
                                        lowContrast={true} 
                                        onClick={VR.hideMsgRegistro}
                                />
                                }
                        </Column>
                        <Column lg={2} md={2} sm={2}> </Column>
                    </Grid>
                    <VR.spanHeight height="5vh" />
                </Column>
            </Grid>
        </Content>
    </>
    );
};

export default ValidaRFC;